import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, Link, Typography } from "@material-ui/core";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import CenteredAuthCard from "../../../../../ui/components/CenteredAuthCard";
import PrimaryButton from "../../../../../ui/components/PrimaryButton";
import { DEFAULT_SPACING } from "../../../../../ui/theme/dimensions";

type AvailableLanguages = "en" | "de" | "fr";

//State
interface State {
  termsUrl: string;
}

interface ExternalProps extends WithTranslation {
  onTermsAccepted: () => void;
}

type Props = ExternalProps & WithTranslation;

class TermsAndConditionsPage extends React.Component<Props, State> {
  componentDidMount() {
    this.languageDetector(this.props.i18n.language as AvailableLanguages);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.t !== prevProps.t) {
      this.languageDetector(this.props.i18n.language as AvailableLanguages);
    }
  }

  state = {
    termsUrl: `${window.location.origin}/documents/adey-sense-tnc-en.pdf`,
  };

  //Helpers
  languageDetector = (lng: AvailableLanguages) => {
    const baseUrl = `${window.location.origin}/documents`;
    switch (lng) {
      case "en":
        this.setState({ termsUrl: `${baseUrl}/adey-sense-tnc-en.pdf` });
        return;
      case "de":
        this.setState({ termsUrl: `${baseUrl}/adey-sense-tnc-de.pdf` });
        return;
      case "fr":
        this.setState({ termsUrl: `${baseUrl}/adey-sense-tnc-fr.pdf` });
        return;
    }
  };

  render() {
    const title = this.props.t("termsAndConditionsPage.title");
    const accept = this.props.t("termsAndConditionsPage.acceptButton");
    const reviewMessage = this.props.t("termsAndConditionsPage.reviewMessage");
    const linkText = this.props.t("termsAndConditionsPage.linkText");

    return (
      <CenteredAuthCard
        title={title}
        overflow="hidden"
        width="1000px"
        noMaxWidth
        includeSignOut
      >
        <Grid container spacing={DEFAULT_SPACING} justify="center">
          <Grid item style={{ width: "100%" }}>
            <Box maxHeight="45vh" display="flex" overflow="auto">
              <Box width="100%" padding={2} textAlign="center">
                <Typography variant="body1" paragraph>
                  {reviewMessage}
                </Typography>
                <Link
                  href={this.state.termsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="h6"
                >
                  {linkText}
                </Link>
              </Box>
            </Box>
          </Grid>

          <Grid item>
            <PrimaryButton
              label={accept}
              endIcon={<FontAwesomeIcon icon={faCheck} />}
              onClick={this.props.onTermsAccepted}
            />
          </Grid>
        </Grid>
      </CenteredAuthCard>
    );
  }
}

export default withTranslation()(TermsAndConditionsPage);
